module.exports = __webpack_public_path__ + "media/images/icon__arrow-right@3x-d7244da3b7c17c26139b29ab162def1b.png";